/*
 *   File : dashboard.js
 *   Author : https://evoqins.com
 *   Description : Home page
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal } from 'bootstrap';
import { toast } from 'react-toastify';

//custom Component
import CustomDropdown from '../../Component/FormElements/select';
import { DataTableComponent } from '../../Component/DataTable';
import { EditDetailsModal, AddFieldConfigModal, AddRegexConfigModal } from '../../Component/Modal';
import Loader from '../../Component/Others/loader';
import EmptyScreen from '../../Component/Others/empty';
import { CustomSearchInput } from '../../Component/FormElements';

import { APIService } from "../../Service";
import { PrimaryButton } from '../../Component/Buttons';

const Dashboard = () => {

    const navigate = useNavigate();

    const [editId, setEditId] = useState(null);
    const [editData, setEditData] = useState(null);

    const [addId, setAddId] = useState(null);
    const [addFieldData, setAddFieldData] = useState(null);

    const [addRegexId, setAddRegexId] = useState(null);
    const [addRegexData, setAddRegexData] = useState(null);

    const [loading, setLoading] = useState(false);
    const [countryList, setCountryList] = useState([]);
    const [country, setCountry] = useState(null);
    const [channelList, setChannelList] = useState([]);
    const [channel, setChannel] = useState(null);
    const [listField, setListField] = useState(null);
    const [countryLoading, setCountryLoading] = useState(true);
    const [selectedCorridorId, setSelectedCorridorId] = useState(null);
    const [selectedChannelId, setSelectedChannelId] = useState(null);
    const [removeLoading, setRemoveLoading] = useState(false);
    const [channelError, setChannelError] = useState(null);
    const [searchValue, setSearchValue] = useState("");

    useEffect(() => {
        window.scrollTo({
            top: 0, behavior: 'smooth' //scroll top
        });
        _getCountryList();
    }, []);


    useEffect(() => {
        if (editId !== null) {
            const edit_modal = new Modal(document.getElementById('confirm-edit-modal'));
            edit_modal.show();
        }
    }, [editId]);

    useEffect(() => {
        if (addId !== null) {
            const add_field_modal = new Modal(document.getElementById('add-field-config-modal'));
            add_field_modal.show();
        }
    }, [addId]);


    useEffect(() => {
        if (addRegexId !== null) {
            const add_regex_modal = new Modal(document.getElementById('add-regex-config-modal'));
            add_regex_modal.show();
        }
    }, [addRegexId]);

    // handle Edit
    const _handleEdit = (row) => {
        setEditId(row.id);
        setEditData(row); // new state to hold row's existing values
    };

    const _handleAddField = (row) => {
        setAddId(row.id);
        setAddFieldData(row);
    }

    const _handleAddRegex = (row) => {
        setAddRegexId(row.id);
        setAddRegexData(row); // row contains .regex if exists
    }

    // table 
    const TABLE_COLUMNS = [

        {
            name: 'Field name',
            selector: row => row.name,
            cell: row => (
                <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                    {row.name ? row.name : "-"}
                </div>
            ),
            width: "400px"
        },
        {
            name: 'Mandatory/Optional',
            selector: row => row.priority,
            cell: row => {
                // Normalize to lowercase to handle different casing
                const value = (row.priority);

                let color = '';
                let label = '';
                let icon = '';

                switch (value) {
                    case 'Mandatory':
                        color = '#E08D2D';
                        label = 'Mandatory';
                        icon = require("../../Assets/Images/Home/mandatory-icon.svg").default
                        break;

                    case 'Optional':
                        color = '#43A047';
                        label = 'Optional';
                        icon = require("../../Assets/Images/Home/optional-icon.svg").default
                        break;

                    default:
                        // Covers `nil` or any unexpected value
                        color = '#9E9E9E';
                        label = 'Nil';
                        icon = require("../../Assets/Images/Home/nil-icon.svg").default
                        break;
                }

                return (
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            color: color,
                            fontWeight: 500,
                        }}
                    >
                        {/* <span>{icon}</span> */}
                        <img draggable={false} src={icon} alt='Icon' />
                        <span className='e-primary-font e-font-14'>{label}</span>
                    </div>
                );
            },
            width: "180px"
        },
        {
            name: 'Additional data field number',
            selector: row => row.data_field_number,
            cell: row => (
                <div>
                    {row.data_field_number ? row.data_field_number : "-"}
                </div>
            ),
            width: "180px"
        },
        {
            name: 'Additional data description',
            selector: row => row.description,
            cell: row => (
                <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                    {row.description ? row.description : "-"}
                </div>
            ),
            width: "200px"
        },
        {
            name: 'Type',
            selector: row => row.type,
            width: "100px"
        },
        {
            name: 'Action',
            cell: (row) => (
                <div className="d-flex align-items-center cursor-pointer">
                    {
                        (row.mapping_id === null) ? (
                            <>
                                <img
                                    draggable={false}
                                    width={20}
                                    height={20}
                                    src={require("../../Assets/Images/Home/add-icon.svg").default}
                                    className="me-1"
                                    alt="Add icon"
                                />
                                <span
                                    className="e-edit-btn e-primary-font e-font-weight-500 e-font-14"
                                    onClick={() => _handleAddField(row)}>
                                    Add
                                </span>
                            </>
                        ) : (
                            <>
                                <img
                                    draggable={false}
                                    src={require("../../Assets/Images/Home/edit.svg").default}
                                    className="me-1"
                                    alt="Edit icon"
                                />
                                <span
                                    className="e-edit-btn e-primary-font e-font-weight-500 e-font-14"
                                    onClick={() => _handleEdit(row)}
                                >
                                    Edit
                                </span>
                            </>
                        )
                    }
                </div>
            ),
            width: '100px',
        },
        {
            name: 'Regex',
            width: "160px",
            cell: (row) => (
                <div className="d-flex align-items-center cursor-pointer">
                    {(row.nil === true) ? (
                        <div className="d-flex justify-content-center">-</div>
                    ) : (
                        <div className="d-flex align-items-center">
                            <img
                                draggable={false}
                                width={20}
                                height={20}
                                src={
                                    row.regex
                                        ? require("../../Assets/Images/Home/edit.svg").default
                                        : require("../../Assets/Images/Home/add-icon.svg").default
                                }
                                className="me-1"
                                alt={row.regex ? "Edit icon" : "Add icon"}
                            />
                            <span
                                className="e-edit-btn e-primary-font e-font-weight-500 e-font-14"
                                onClick={() => _handleAddRegex(row)}
                            >
                                {row.regex ? "Edit" : "Add"}
                            </span>
                        </div>
                    )}
                </div>
            )
        }

    ];

    // API - Get country list
    const _getCountryList = () => {
        const is_post = false;
        const url = 'corridor/list';

        APIService(is_post, url, {}).then((response) => {
            if (response.status_code === 200) {
                const mappedData = response.data.map((item) => ({
                    label: item.name,
                    value: item.id,
                }));
                setCountryList(mappedData);

                // 🔹 If currently selected country is no longer in list, reset it
                if (country && !mappedData.some((c) => c.value === country.value)) {
                    setCountry(null);
                    setChannelList([]);
                    setChannel(null);
                    setSelectedCorridorId(null);
                    setSelectedChannelId(null);
                }
            }
            setCountryLoading(false);
        });
    };

    // API - Get channel list
    const _getChannelList = (corridorId) => {
        const is_post = true;
        const url = 'channel/list';
        const data = {
            corridor_id: corridorId
        };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                const mappedData = response.data.map((item) => ({
                    label: item.name,
                    value: item.id,
                }));
                setChannelList(mappedData);

                // Automatically set default channel (ID = 1)
                const defaultChannel = mappedData.find((ch) => ch.value === 1) || mappedData[0];
                setChannel(defaultChannel);

                // Set selected channel ID here
                setSelectedChannelId(defaultChannel?.value);

                // Fetch field mapping using selected country and default channel
                if (defaultChannel) {
                    _fetchCountryData(corridorId, defaultChannel.value);
                }
                setChannelError(null);
            } else {
                setChannelList([]);
                setChannel(null);
                _getCountryList();   // 🔹 refresh countries again
                // setChannelError(response.message); // store error
                // setListField({ data: [] });
            }
        });
    };

    // get country related data
    const _fetchCountryData = (corridorId, channelId, query = searchValue) => {
        setLoading(true);
        const is_post = true;
        const url = 'field-mapping/list';
        const data = {
            corridor_id: corridorId,
            channel_id: channelId,
            search_query: query
        };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setListField({ data: response.data });
            } else {
                setListField({ data: [] });
                toast.dismiss();
                toast.error(response.message, {
                    type: 'error',
                    className: 'e-toast',
                });
            }
            setLoading(false);
        });
    };

    // API - Delete channel
    const _deleteChannel = (channelId) => {
        setRemoveLoading(true);
        const is_post = true;
        const url = 'channel/delete';
        const data = { channel_id: channelId };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                toast.dismiss();
                toast.success(response.message, {
                    type: "success",
                    className: "e-toast",
                });
                // Refresh countries (since API might remove corridor if no channels left)

                // Refresh channel list after deletion
                if (country) {
                    _getChannelList(country.value);
                }
                _getCountryList();
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: 'error',
                    className: 'e-toast',
                });
            }
            setRemoveLoading(false);
        });
    };


    return (

        <div className='pt-3 padding-98px-bottom padding-32px-lr'>
            <div className='row'>
                <div className='col-lg-6 col-md-6 col-sm-6'>
                    <h1 className='pt-3 e-primary-font e-font-weight-600 e-font-24'>Corridor config</h1>
                </div>
                <div className='offset-xl-2 col-xl-4 col-lg-5 col-md-6 col-sm-6 my-auto'>
                    {
                        country && channelList.length > 0 && (
                            <div className='position-relative overflow-hidden'>
                                <CustomSearchInput placeholder="Search with field name"
                                    type="text"
                                    id="search"
                                    require
                                    search
                                    value={searchValue}
                                    className="w-100 padding-10px-tb pe-3"
                                    // borderStyle="border-transparent"
                                    labelStyle="e-font-weight-500"
                                    handleChange={(value) => {
                                        setSearchValue(value);

                                        // Auto refresh when search becomes empty
                                        if (value === "") {
                                            _fetchCountryData(selectedCorridorId, selectedChannelId, "");
                                        }
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            _fetchCountryData(
                                                selectedCorridorId,
                                                selectedChannelId,
                                                searchValue
                                            )
                                        }
                                    }}
                                />

                                {searchValue.length !== 0 &&
                                    <span className='position-absolute h-100 top-0 px-3 d-flex align-items-center justify-content-center e-bg-primary-blue end-0 cursor-pointer'
                                        style={{ borderRadius: "0 8px 8px 0" }}
                                        onClick={() => _fetchCountryData(selectedCorridorId, selectedChannelId,searchValue)}
                                    >
                                        <img src={require('../../Assets/Images/Home/arrow.svg').default}
                                            className=''
                                            width={14}
                                            height={14}
                                            alt='Search'
                                        />
                                    </span>}

                                {searchValue.length !== 0 &&
                                    <img src={require('../../Assets/Images/Home/close.png')}
                                        className='position-absolute top-14px right-64px cursor-pointer'
                                        width={14}
                                        height={14}
                                        alt='Close'
                                        onClick={() => {
                                            setSearchValue("");
                                            _fetchCountryData(selectedCorridorId, selectedChannelId, "");  // refresh table

                                        }} />
                                }
                            </div>
                        )}
                </div>
            </div>

            <div className='row mt-3'>
                <div className='col-xl-3 col-lg-4 col-md-4 col-sm-6 mb-lg-0 mb-md-0 mb-sm-0 mb-3'>
                    {/* select country */}
                    <CustomDropdown
                        label="Destination Country"
                        options={countryList}
                        value={country?.value}
                        labelStyle='e-font-weight-400'
                        onChange={(selectedCountry) => {
                            setCountry(selectedCountry);
                            setSelectedCorridorId(selectedCountry.value);
                            _getChannelList(selectedCountry.value);
                        }}
                        placeholder="Select Country"
                        labelKey="label"
                        valueKey="value"
                        listClassName="e-select-overflow"
                        loading={countryLoading}
                    />
                </div>

                <div className='col-xl-3 col-lg-4 col-md-4 col-sm-6'>
                    {/* select channel */}
                    {
                        country && channelList.length > 0 && (
                            <CustomDropdown
                                label="Channel"
                                labelStyle="e-font-weight-400"
                                options={channelList}
                                value={channel?.value}
                                onChange={(selectedChannel) => {
                                    setChannel(selectedChannel);
                                    setSelectedChannelId(selectedChannel.value);
                                    _fetchCountryData(country.value, selectedChannel.value);
                                }}
                                placeholder="Select Channel"
                                labelKey="label"
                                valueKey="value"
                                searchable={false}
                            />
                        )
                    }

                </div>

                <div className='co-xl-3 col-lg-4 col-md-4 col-sm-6 col-6 my-auto'>
                    {
                        country && channelList.length > 0 && (
                            <PrimaryButton name="Remove corridor"
                                className="e-bg-primary-blue mt-4 w-75"
                                status={removeLoading}
                                onPress={() => {
                                    if (channel?.value) {
                                        _deleteChannel(channel.value);
                                    }
                                }} />
                        )}
                </div>


            </div>


            {country && (
                loading ? (
                    <Loader />
                ) : channelError ? (
                    <div className='h-100vh pt-5 mt-5'>
                        <EmptyScreen message={channelError} />
                    </div>
                ) : !listField ? (
                    <></>
                ) : listField.data.length > 0 ? (
                    <div className='row mt-4'>
                        <div className='col-lg-12'>
                            <div className='e-table'>
                                <DataTableComponent
                                    columns={TABLE_COLUMNS}
                                    data={listField.data}
                                    pagination={false}
                                    paginationServer={false}
                                />
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className='h-100vh pt-5 mt-5'>
                        <EmptyScreen message="No data found" />
                    </div>
                )
            )}


            {/* edit modal  */}
            {editId !== null &&
                <EditDetailsModal
                    fieldData={editData}              //  Pass existing row data
                    // corridorId={selectedCorridorId}
                    // channelId={selectedChannelId}
                    handleClose={() => {
                        setEditId(null);
                        setEditData(null);
                    }}
                    onUpdate={() => {
                        _fetchCountryData(selectedCorridorId, selectedChannelId);
                    }} />
            }

            {/* Add field modal */}
            {addId !== null &&
                <AddFieldConfigModal
                    fieldData={addFieldData}
                    corridorId={selectedCorridorId}
                    channelId={selectedChannelId}
                    handleClose={() => {
                        setAddId(null);
                        setAddFieldData(null);
                    }}
                    onUpdate={() => {
                        _fetchCountryData(selectedCorridorId, selectedChannelId);
                    }}
                />
            }


            {/* Add Regex modal */}
            {addRegexId !== null &&
                <AddRegexConfigModal
                    fieldData={addRegexData}
                    corridorId={selectedCorridorId}
                    channelId={selectedChannelId}
                    handleClose={() => {
                        setAddRegexId(null);
                        setAddRegexData(null);
                    }}
                    onUpdate={() => {
                        // Re-fetch the list or optimistically update the row
                        _fetchCountryData(selectedCorridorId, selectedChannelId);
                    }}
                />

            }

        </div>

    )
}

export default Dashboard;